import apiClient from '@/services/axios'

export async function get(surveySessionId) {
  var response = await apiClient.get(`/VenueVisitSessions/details/${surveySessionId}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get venue visits')
}
